import { render, staticRenderFns } from "./PdfContentClickB2b.vue?vue&type=template&id=7edf5418&scoped=true&"
import script from "./PdfContentClickB2b.vue?vue&type=script&lang=js&"
export * from "./PdfContentClickB2b.vue?vue&type=script&lang=js&"
import style0 from "./PdfContentClickB2b.vue?vue&type=style&index=0&id=7edf5418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edf5418",
  null
  
)

export default component.exports